import { useEffect, useState } from 'react';

import { useAppSelector } from '../store/hooks';

export default function useGetCommissionsAvailableBalance() {
  const { value: acctBalValue } = useAppSelector(
    (state) => state.getCommissionBalance
  );

  const availableCommissionBalanceFromStorage = localStorage.getItem(
    'availableCommissionBalance'
  );

  const parsedAvailableBalance = availableCommissionBalanceFromStorage
    ? (JSON.parse(availableCommissionBalanceFromStorage) as number)
    : null;

  const availableCommissionBalance = acctBalValue?.data?.availableBalance;

  const [availableCommissionBalanceState, setAvailableBalanceState] = useState(
    parsedAvailableBalance
  );

  useEffect(() => {
    if (availableCommissionBalance !== undefined) {
      localStorage.setItem(
        'availableCommissionBalance',
        JSON.stringify(availableCommissionBalance)
      );

      setAvailableBalanceState(availableCommissionBalance);
    }
  }, [availableCommissionBalance]);

  return availableCommissionBalanceState !== null
    ? availableCommissionBalanceState / 100
    : null;
}
